<div class="card">
  <div class="flex align-items-center justify-content-between mb-4">
    <app-header
      titulo="Dashboard de Monitoramento"
      descricao="Acompanhe a saúde das integrações em tempo real.">
    </app-header>
    
    <div class="flex align-items-center">
      <p-selectButton 
        [options]="[{label: '24h', value: '24h'}, {label: '7d', value: '7d'}, {label: '30d', value: '30d'}]" 
        [(ngModel)]="periodo" 
        (onChange)="alterarPeriodo($event.value)">
      </p-selectButton>
      <p-button 
        icon="pi pi-refresh" 
        styleClass="p-button-rounded p-button-text ml-2" 
        (onClick)="carregarDados()" 
        [loading]="loading">
      </p-button>
    </div>
  </div>

  <div *ngIf="loading && !dashboardData" class="text-center p-5">
    <p-progressSpinner></p-progressSpinner>
    <p>Carregando métricas...</p>
  </div>

  <div *ngIf="!loading && !dashboardData" class="text-center p-5 surface-50 border-round">
    <i class="pi pi-exclamation-triangle text-4xl text-warning mb-3"></i>
    <h3 class="text-900">Não foi possível carregar os dados</h3>
    <p class="text-600">Verifique se o backend de monitoramento está ativo na porta 7772 ou se há registros processados.</p>
    <p-button label="Tentar Novamente" icon="pi pi-refresh" styleClass="p-button-outlined mt-3" (onClick)="carregarDados()"></p-button>
  </div>

  <div *ngIf="dashboardData">
    <!-- Cards de Métricas -->
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-3">
        <app-estatistica-card
          titulo="Processos Ativos"
          [valor]="dashboardData.metricas.processosAtivos"
          icone="pi pi-bolt"
          bgColor="var(--green-100)"
          iconColor="var(--green-500)"
          [subtitulo]="dashboardData.metricas.processosInativos + ' inativos'">
        </app-estatistica-card>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <app-estatistica-card
          titulo="Registros Recebidos"
          [valor]="dashboardData.metricas.registrosRecebidos.total"
          icone="pi pi-inbox"
          bgColor="var(--blue-100)"
          iconColor="var(--blue-500)"
          [subtitulo]="dashboardData.metricas.registrosRecebidos.taxaSucesso + '% sucesso'">
        </app-estatistica-card>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <app-estatistica-card
          titulo="Tempo Médio"
          [valor]="(dashboardData.metricas.performance.tempoMedioProcessamentoMs / 1000 | number:'1.1-2') + 's'"
          icone="pi pi-clock"
          bgColor="var(--orange-100)"
          iconColor="var(--orange-500)"
          [subtitulo]="'Min: ' + (dashboardData.metricas.performance.tempoMinimoMs / 1000 | number:'1.1-2') + 's'">
        </app-estatistica-card>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <app-estatistica-card
          titulo="Falhas Críticas"
          [valor]="dashboardData.metricas.registrosRecebidos.erro"
          icone="pi pi-exclamation-circle"
          bgColor="var(--red-100)"
          iconColor="var(--red-500)"
          subtitulo="Necessitam atenção">
        </app-estatistica-card>
      </div>
    </div>

    <!-- Gráficos -->
    <div class="grid mt-2">
      <div class="col-12 lg:col-8">
        <p-card header="Volume de Registros">
          <p-chart type="line" [data]="chartData" [options]="chartOptions" [height]="'350px'"></p-chart>
        </p-card>
      </div>
      <div class="col-12 lg:col-4">
        <p-card header="Distribuição de Status">
          <p-chart type="pie" [data]="pieData" [options]="pieOptions" [height]="'350px'"></p-chart>
        </p-card>
      </div>
    </div>

    <!-- Top Processos -->
    <div class="grid mt-2">
      <div class="col-12 md:col-6">
        <p-card header="Top Processos (Volume)">
          <p-table [value]="dashboardData.topProcessos.maisRegistros" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr>
                <th>Processo</th>
                <th style="width: 100px" class="text-right">Registros</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-proc>
              <tr>
                <td>{{ proc.nome }}</td>
                <td class="text-right">{{ proc.totalRegistros }}</td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </div>
      <div class="col-12 md:col-6">
        <p-card header="Top Processos (Erros)">
          <p-table [value]="dashboardData.topProcessos.maisErros" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr>
                <th>Processo</th>
                <th style="width: 100px" class="text-right">Erros</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-proc>
              <tr>
                <td>{{ proc.nome }}</td>
                <td class="text-right text-red-500">{{ proc.totalErros }}</td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </div>
    </div>
  </div>
</div>
